import SkapaTabs from "@coworker/app/src/components/InputPopup/SkapaTabs";
import { useTranslation } from "@coworker/locales";
import React from "react";
import styles from "./task-state-tabs.module.css";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { ActivityColumns } from "../../constants/activityColumns";

type TasksCount = {
  open: number | string;
  inProgress: number | string;
  completed: number | string;
  closed: number | string;
};

interface TaskStateTabsProps {
  activeTab: ActivityColumns;
  setActiveTab: React.Dispatch<React.SetStateAction<ActivityColumns>>;
  tasksCount: TasksCount;
  openTasksLoading: boolean;
  inProgressTasksLoading: boolean;
  completedTasksLoading: boolean;
  closedTasksLoading: boolean;
}

export const TaskStateTabs = ({
  activeTab,
  setActiveTab,
  tasksCount,
  openTasksLoading,
  inProgressTasksLoading,
  completedTasksLoading,
  closedTasksLoading,
}: TaskStateTabsProps) => {
  const { t } = useTranslation();

  const tabs = [
    {
      title: (
        <>
          {t("teamOpenString")} {!openTasksLoading && tasksCount.open}
        </>
      ),
      key: ActivityColumns.OPEN,
    },
    {
      title: (
        <>
          {t("inProgressString")}{" "}
          {!inProgressTasksLoading && tasksCount.inProgress}
        </>
      ),
      key: ActivityColumns.IN_PROGRESS,
    },
    {
      title: (
        <>
          {t("completd3String")}{" "}
          {!completedTasksLoading && tasksCount.completed}
        </>
      ),
      key: ActivityColumns.COMPLETED,
    },
    {
      title: (
        <>
          {t("teamClosedString")} {!closedTasksLoading && tasksCount.closed}
        </>
      ),
      key: ActivityColumns.CLOSED,
    },
  ];

  const tabChangedHandler = (tabKey: ActivityColumns) => {
    setActiveTab(tabKey);
    trackerHelper.trackActivityTabClick(tabKey);
  };

  return (
    <div className={styles["task-state-tabs"]}>
      <SkapaTabs
        tabs={tabs}
        active={activeTab}
        onTabChanged={tabChangedHandler}
        noTabPanelPadding
      />
    </div>
  );
};
